// Store listings. The Android package id matches android/app/build.gradle.kts.
export const GOOGLE_PLAY_URL =
  "https://play.google.com/store/apps/details?id=com.allading.voice";

// TODO: replace with the App Store listing URL (https://apps.apple.com/app/id<APPLE_ID>)
// once the app id is assigned in App Store Connect.
export const APP_STORE_URL = "";

export const SUPPORT_EMAIL = "support@allading.com";
